<template>
  <div id="contenedor-respuesta-detalle-observacion">
    <v-form
      v-model="formularioValido"
      ref="registrarNuevaRespuestaDetalleObservacion">
      <v-card>
        <v-card-title>
          <span v-if="tipo === 1">
            Anexar archivo al seguimiento
          </span>
          <span v-else>
            Agregar Especificaciones del Desglose
          </span>
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <v-row>
            <v-col v-show="tipo === 1" cols="12">
              <TextArea
                v-model="respuesta.accion"
                label="Acción/Documento"
                rows="3"
                placeholder=""
                clearable>
              </TextArea>
            </v-col>
            <v-card flat class="selected ma-4 pa-4" width="100%">
              <v-row align="center" justify="center">
                <v-file-input
                  v-model="anexo"
                  show-size
                  label="Seleccionar Archivo PDF"
                  type="file"
                  ref="anexoDocumento"
                  name="anexo"
                  id="anexo"
                  hide-details
                  accept=".pdf, .doc, .docx, .txt, .xls, .xlsx, .csv, .zip, .rar, image/*"
                  :rules="[mixReglas.requerido]"
                  >
                  </v-file-input>
              </v-row>
            </v-card>
            <v-col cols="12" v-show="tipo === 1">
              <TextArea
                v-model="respuesta.comentarios"
                label="Comentarios"
                rows="3"
                placeholder="">
              </TextArea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
            </custom-button>
          <custom-button
            @click="guadar"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario "
            :loading="enviandoFormulario"
            >
            </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import LISTADO_SEGUIMIENTO_DETALLE_OBSERVACION from '@/graphql/querys/administracion/auditorias/auditoriaInformeObservacionDetalleSeguimientos.gql';
import AGREGAR_RESPUESTA_OBSERVACION_DETALLE from '@/graphql/mutations/administracion/auditorias/observaciones/detalles/agregarAuditoriaInformeObservacionDetalleRespuesta.gql';
import TextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixSubirArchivo from '@/helpers/mixSubirArchivo';

export default {
  name: 'RegistrarNuevaRespuestaDetalleObservacion',
  mixins: [mixSubirArchivo],
  components: {
    TextArea,
    CustomButton,
  },
  props: {
    detalle: {
      type: Object,
      required: true,
    },
    tipo: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      anexo: [],
      respuesta: {
        idAuditoriaInformeObservacionDetalle: this.detalle.id,
        accion: this.detalle.texto || null,
        comentarios: null,
        tipo: this.tipo,
        fileData: null,
      },
    };
  },
  apollo: {
    auditoriaInformeObservacionDetalleSeguimientos: {
      query: LISTADO_SEGUIMIENTO_DETALLE_OBSERVACION,
      variables() {
        return {
          idAuditoriaInformeObservacionDetalle: this.detalle.id,
          tipo: this.tipo, // 1 for responses, 2 for specifications
        };
      },
    },
  },
  methods: {
    async guadar() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      if (document.getElementById('anexo').files.length === 1) {
        const file = document.getElementById('anexo').files[0];

        const uploadedFile = await this.mixSubirArchivo(file);

        if (uploadedFile.status === 'ok') {
          this.respuesta.fileData = JSON.stringify(uploadedFile.data);
        }
      }

      await this.$apollo.mutate({
        mutation: AGREGAR_RESPUESTA_OBSERVACION_DETALLE,
        variables: {
          seguimiento: this.respuesta,
        },
      }).then(async () => {
        await this.$apollo.queries.auditoriaInformeObservacionDetalleSeguimientos.refetch({
          idAuditoriaInformeObservacionDetalle: this.detalle.id,
          tipo: this.tipo,
        });
        this.mixMensajeSuccess();
        this.$emit('success');

        this.cerrar();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
    limpiarFormulario() {
      this.$refs.registrarNuevaRespuestaDetalleObservacion.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  watch: {
    detalle: {
      handler(detalle) {
        this.respuesta.accion = detalle.texto || null;
      },
    },
  },
};
</script>

<style lang="scss">

</style>
